import { useMutation } from "@tanstack/react-query";
import { useUser } from "../useUserProvider";
import { request } from "@/lib/request";
import { Element } from "@/components/elements/UIElement";
export const useCreateProfile = () => {
  const { accessToken } = useUser();

  return useMutation({
    mutationKey: ["createProfile"],
    meta: {
      analytics: {
        successEvent: "dashboard_profile_created",
      },
    },
    mutationFn: async ({
      name,
      elements,
    }: {
      name: string;
      elements: Element[];
    }): Promise<{
      data: { id: string };
    }> => {
      if (!accessToken) {
        throw new Error("You need to be logged in to create a profile.");
      }

      const res = await request
        .post(`/profile`, {
          name,
          elements: elements.map(({ config, ...element }) => ({
            ...element,
            config: JSON.stringify(config),
          })),
        })
        .catch(err => {
          throw new Error(
            err.response?.data.message
              ? err.response?.data.message
              : "Something went wrong, please try again.",
          );
        });

      return res.data;
    },
  });
};
